'use client';

import { useEffect } from 'react';
import { useState } from 'react';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { getUsefulLinks } from '@/app/[locale]/store/actions';
import { UsefulLinksResponse } from '@/types/useful-link';

export const UsefulLinks = () => {
    const t = useTranslations();
    const [isLoading, setIsLoading] = useState(true);
    const [usefulLinks, setUsefulLinks] = useState<UsefulLinksResponse>([]);

    useEffect(() => {
        const fetchUsefulLinks = async () => {
            const links = await getUsefulLinks();
            setUsefulLinks(links);
            setIsLoading(false);
        };

        fetchUsefulLinks();
    }, []);

    const hasUsefulLinks = usefulLinks && usefulLinks.length > 0;

    if (!hasUsefulLinks) {
        return null;
    }

    return (
        <div className='flex w-full flex-col items-center gap-4 lg:w-auto lg:max-w-[200px] lg:items-start'>
            <p className='text-[16px] font-[800] leading-[100%] tracking-normal'>{t('useful-links')}</p>
            {isLoading ? (
                <div className='flex justify-center'>
                    <div className='border-t-primary size-5 animate-spin rounded-full border-2 border-gray-300'></div>
                </div>
            ) : (
                <div className='flex w-full flex-col items-center gap-2 lg:items-start'>
                    {usefulLinks.map(link => (
                        <Link
                            key={link.id}
                            href={link.link}
                            target='_blank'
                            rel='noopener noreferrer'
                            className='text-[12px] font-[500] leading-[18px] tracking-normal'
                        >
                            {link.title ?? link.link}
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
};
